import { ICityTaxAutoFile } from '../../../interfaces';

class CityTaxAutoFileMapper {

    toPersistence(domainCityTaxAutoFile: ICityTaxAutoFile): any {
        return {
            id: domainCityTaxAutoFile.id,
            file_name: domainCityTaxAutoFile.file_name,
            import_progress: domainCityTaxAutoFile.import_progress,
            status: domainCityTaxAutoFile.status,
            created_at: domainCityTaxAutoFile.created_at,
            updated_at: domainCityTaxAutoFile.updated_at,
        }
    }

    toDomain(persistenceCityTaxAutoFile: any): ICityTaxAutoFile {
        return {
            id: persistenceCityTaxAutoFile.id,
            file_name: persistenceCityTaxAutoFile.file_name,
            import_progress: persistenceCityTaxAutoFile.import_progress,
            status: persistenceCityTaxAutoFile.status,
            city_tax_auto_id: persistenceCityTaxAutoFile.city_tax_auto_id,
            file: persistenceCityTaxAutoFile.file,
            created_at: persistenceCityTaxAutoFile.created_at,
            updated_at: persistenceCityTaxAutoFile.updated_at,
        }
    }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new CityTaxAutoFileMapper();
